var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pushTalks scrollbar grayColor contents"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm.State.partyJoinInfo.owner && _vm.State.partyJoinInfo.channelMode === 0 ? _c('h4', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pushTalk.pushTalk')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "disabled": _vm.State.audioMatrixEnable || _vm.State.intercomEnable,
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changePushTalk
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.showMutexTip.apply(null, arguments);
      }
    },
    model: {
      value: _vm.pushTalkEnable,
      callback: function ($$v) {
        _vm.pushTalkEnable = $$v;
      },
      expression: "pushTalkEnable"
    }
  })], 1) : _vm._e(), _vm.State.partyJoinInfo.owner && _vm.State.partyJoinInfo.channelMode === 0 ? _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "leftText"
  }, [_vm._v(_vm._s(_vm.$t('setting.turnOn')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('pushTalk.pushTalkTips')))])])]) : _vm._e(), _vm.State.partyJoinInfo.owner && _vm.State.partyJoinInfo.channelMode === 0 && _vm.pushTalkEnable ? _c('div', {
    staticClass: "title participantTitle"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('pushTalk.enableParticipants')))]), _c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pushTalk.notSupport')))])])])], 1), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeParticipantPushTalk(_vm.participantsEnable, 'pipEnable');
      }
    },
    model: {
      value: _vm.participantsEnable,
      callback: function ($$v) {
        _vm.participantsEnable = $$v;
      },
      expression: "participantsEnable"
    }
  })], 1) : _vm._e(), _vm.State.partyJoinInfo.owner && _vm.State.partyJoinInfo.channelMode === 0 && _vm.pushTalkEnable ? _c('div', {
    staticClass: "title participantTitle"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('pushTalk.muteAudio')))])]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeParticipantPushTalk(_vm.muteAduio, 'muAudio');
      }
    },
    model: {
      value: _vm.muteAduio,
      callback: function ($$v) {
        _vm.muteAduio = $$v;
      },
      expression: "muteAduio"
    }
  })], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pushTalkEnable || _vm.State.participantPushTalkOpen || !_vm.State.partyJoinInfo.owner && _vm.participantsEnable,
      expression: "pushTalkEnable || State.participantPushTalkOpen || (!State.partyJoinInfo.owner && participantsEnable)"
    }],
    staticClass: "manageBox"
  }, [_c('span', {
    staticClass: "manageTips"
  }, [_vm._v(_vm._s(_vm.$t('pushTalk.manageTips')))]), _c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pushTalk.groupTips1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('pushTalk.groupTips2')))])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pushTalkEnable || _vm.State.participantPushTalkOpen || !_vm.State.partyJoinInfo.owner && _vm.participantsEnable,
      expression: "pushTalkEnable || State.participantPushTalkOpen || (!State.partyJoinInfo.owner && participantsEnable)"
    }],
    staticClass: "groupContnt scrollbar grayColor",
    class: {
      participant: _vm.State.participantPushTalkOpen
    }
  }, _vm._l(_vm.groupArray, function (item, index) {
    return _c('el-collapse', {
      key: item.id,
      staticClass: "pushTalk",
      attrs: {
        "accordion": ""
      },
      model: {
        value: item.activeName,
        callback: function ($$v) {
          _vm.$set(item, "activeName", $$v);
        },
        expression: "item.activeName"
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "name": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "headerLeft"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !item.edit,
        expression: "!item.edit"
      }]
    }, [_c('span', {
      staticClass: "headTitle"
    }, [_vm._v(_vm._s(item.groupName))]), item.rtilCodeList.length ? _c('span', {
      staticClass: "members"
    }, [_vm._v(_vm._s(item.rtilCodeList.length) + " " + _vm._s(_vm.$t('pushTalk.people')))]) : _c('span', {
      staticClass: "members"
    }, [_vm._v(_vm._s(_vm.$t('pushTalk.noMembers')))])]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.edit,
        expression: "item.edit"
      }]
    }, [_c('el-input', {
      ref: `renameInput${index}`,
      refInFor: true,
      staticClass: "editInput",
      attrs: {
        "size": "small",
        "maxlength": 50
      },
      on: {
        "blur": function ($event) {
          item.edit = false;
        }
      },
      nativeOn: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          $event.stopPropagation();
          return _vm.saveGroupName(item);
        }
      },
      model: {
        value: item.reName,
        callback: function ($$v) {
          _vm.$set(item, "reName", $$v);
        },
        expression: "item.reName"
      }
    })], 1)]), _c('div', {
      staticClass: "headerRight"
    }, [_c('el-tooltip', {
      attrs: {
        "placement": "top",
        "content": _vm.$t('pushTalk.delete')
      }
    }, [_c('i', {
      staticClass: "iconfont icon-delete1 commonIcon",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.deleteGroup(item, index);
        }
      }
    })]), _c('el-tooltip', {
      attrs: {
        "placement": "top",
        "content": _vm.$t('pushTalk.rename')
      }
    }, [_c('i', {
      staticClass: "iconfont icon-rename1 commonIcon",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.showGroupEdit(item, index);
        }
      }
    })]), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "click",
        "popper-class": "assignPopper"
      },
      on: {
        "show": function ($event) {
          return _vm.participantsSort(item);
        }
      }
    }, [_c('el-tooltip', {
      attrs: {
        "slot": "reference",
        "placement": "top",
        "content": _vm.$t('pushTalk.assign')
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "iconfont icon-assign2 commonIcon",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return (() => {}).apply(null, arguments);
        }
      }
    })]), _c('div', {
      staticClass: "assignContent"
    }, [_c('el-input', {
      staticClass: "assignInput",
      attrs: {
        "placeholder": _vm.$t('pushTalk.inputName'),
        "prefix-icon": "el-icon-search",
        "size": "small"
      },
      on: {
        "input": val => {
          _vm.filterParticipantList(val, item);
        }
      },
      model: {
        value: _vm.assignInput,
        callback: function ($$v) {
          _vm.assignInput = $$v;
        },
        expression: "assignInput"
      }
    }), _vm._l(item.allRtilCodes, function (rtilCode, index) {
      return _c('div', {
        key: index,
        staticClass: "nameLi",
        class: {
          active: item.rtilCodeList.includes(rtilCode),
          disabled: rtilCode == _vm.State.partyJoinInfo.rtilCode
        },
        on: {
          "click": function ($event) {
            return _vm.controlParticipant(item, rtilCode);
          }
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.State.globalNameInfo[rtilCode]))]), _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: item.rtilCodeList.includes(rtilCode),
          expression: "item.rtilCodeList.includes(rtilCode)"
        }],
        staticClass: "el-icon-check"
      })]);
    })], 2)], 1), _c('el-tooltip', {
      attrs: {
        "placement": "top",
        "content": _vm.showShortCutTips(index)
      }
    }, [_c('span', {
      staticClass: "shortCut"
    }, [_vm._v(_vm._s(index + 1))])])], 1)]), _c('div', {
      staticClass: "nameBox scrollbar grayColor"
    }, _vm._l(item.rtilCodeList, function (rtilCode, index) {
      return _c('div', {
        key: index,
        staticClass: "nameLi"
      }, [_c('div', {
        staticClass: "memberName"
      }, [_vm._v(" " + _vm._s(_vm.State.globalNameInfo[rtilCode]) + " "), rtilCode == _vm.State.partyJoinInfo.rtilCode ? _c('span', [_vm._v("(" + _vm._s(_vm.$t('aiSpeech.me')) + ")")]) : _vm._e()]), _c('div', {
        staticClass: "iconBox"
      }, [_c('el-tooltip', {
        attrs: {
          "slot": "reference",
          "placement": "top",
          "content": _vm.$t('invite.remove')
        },
        slot: "reference"
      }, [rtilCode != _vm.State.partyJoinInfo.rtilCode ? _c('i', {
        staticClass: "iconfont icon-delete1 pointer",
        on: {
          "click": function ($event) {
            return _vm.removeParticipant(item, rtilCode);
          }
        }
      }) : _vm._e()]), _c('el-popover', {
        attrs: {
          "placement": "bottom-start",
          "width": "200",
          "trigger": "click",
          "popper-class": "movePopper"
        },
        on: {
          "show": function ($event) {
            return _vm.dealAllGroupArray(item);
          }
        }
      }, [_c('el-tooltip', {
        attrs: {
          "slot": "reference",
          "placement": "top",
          "content": _vm.$t('pushTalk.move')
        },
        slot: "reference"
      }, [rtilCode != _vm.State.partyJoinInfo.rtilCode ? _c('i', {
        staticClass: "iconfont icon-a-V2move pointer"
      }) : _vm._e()]), _c('div', {
        staticClass: "moveBox"
      }, [_c('div', {
        staticClass: "moveBoxTitle"
      }, [_vm._v(_vm._s(_vm.$t('pushTalk.moveTitle')))]), _c('div', {
        staticClass: "groupList"
      }, _vm._l(_vm.allGroupArray, function (groupItem) {
        return _c('div', {
          key: groupItem.groupName,
          staticClass: "groupLi",
          class: {
            active: groupItem.select
          },
          on: {
            "click": function ($event) {
              return _vm.sendMoveParticipant(groupItem, rtilCode, item);
            }
          }
        }, [_c('span', [_vm._v(_vm._s(groupItem.groupName))]), _c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: groupItem.select,
            expression: "groupItem.select"
          }],
          staticClass: "el-icon-check"
        })]);
      }), 0), _c('div', {
        staticClass: "moveFoot"
      }, [_c('el-button', {
        staticClass: "green",
        attrs: {
          "type": "primary",
          "icon": "el-icon-plus",
          "size": "small"
        },
        on: {
          "click": function ($event) {
            return _vm.showCreateGroupBox(rtilCode);
          }
        }
      }, [_vm._v(" " + _vm._s(_vm.$t('pushTalk.room')) + " ")])], 1)])], 1)], 1)]);
    }), 0)], 2)], 1);
  }), 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pushTalkEnable || _vm.State.participantPushTalkOpen || !_vm.State.partyJoinInfo.owner && _vm.participantsEnable,
      expression: "pushTalkEnable || State.participantPushTalkOpen || (!State.partyJoinInfo.owner && participantsEnable)"
    }],
    staticClass: "foot"
  }, [_c('el-button', {
    staticClass: "green",
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "small"
    },
    on: {
      "click": () => {
        _vm.showCreateGroupBox();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pushTalk.room')) + " ")])], 1), _c('tipsDailog', {
    ref: "createGroupDialog",
    staticClass: "createGroupDailog",
    attrs: {
      "info": _vm.createGroupInfo
    },
    on: {
      "save": _vm.saveCreateGroup
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "groupBox"
  }, [_c('span', {
    staticClass: "groupNameText"
  }, [_vm._v(_vm._s(_vm.$t('pushTalk.groupName')))]), _c('el-input', {
    staticClass: "groupNameInput",
    attrs: {
      "maxlength": 50
    },
    model: {
      value: _vm.inputGroupName,
      callback: function ($$v) {
        _vm.inputGroupName = $$v;
      },
      expression: "inputGroupName"
    }
  })], 1), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "placeholder": _vm.$t('pushTalk.participantHolder'),
      "prefix-icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "input": inputVal => {
        _vm.filterCreateParticipantList(inputVal);
      }
    },
    model: {
      value: _vm.participantNameInput,
      callback: function ($$v) {
        _vm.participantNameInput = $$v;
      },
      expression: "participantNameInput"
    }
  }), _vm._l(_vm.participantList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "participantLi",
      class: {
        active: item.hasSelect,
        disabled: item.rtilCode == _vm.State.partyJoinInfo.rtilCode
      },
      on: {
        "click": function ($event) {
          return _vm.saveParticipantList(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.State.globalNameInfo[item.rtilCode]))]), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.hasSelect,
        expression: "item.hasSelect"
      }],
      staticClass: "el-icon-check"
    })]);
  })], 2)])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };